import MobileOffIcon from '@mui/icons-material/MobileOff';
import {type Theme, useTheme} from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {keyframes, type SxProps} from '@mui/system';
import type {FC} from 'react';
import {useTranslation} from 'react-i18next';
import IsoLogo from '@/components/common/logos/IsoLogo';

const UnsupportedDevice: FC = () => {
  const theme = useTheme();
  const {t} = useTranslation();

  const rotateLeft = keyframes`
  0% { transform: rotate(45deg); }
  50% { transform: rotate(-45deg); }
  100% { transform: rotate(45deg); }
`;

  const styles = (theme: Theme): Record<string, SxProps> => ({
    container: {
      background: theme.palette.primary.gradient,
      height: '100dvh',
      width: '100vw',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'fixed',
      inset: 0,
      zIndex: 7000,
      overflow: 'hidden',
    },
    messagge: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    icon: {
      color: 'common.white',
      fontSize: '96px',
    },
    iconAnimation: {
      animation: `${rotateLeft} 4s infinite`,
      display: 'inline-block',
    },
    text: {
      color: 'common.white',
      m: 4,
      textAlign: 'center',
      px: 2,
    },
    logo: {
      position: 'absolute',
      bottom: 8,
      left: 8,
    },
  });

  return (
    <Box sx={styles(theme).container}>
      <Box sx={styles(theme).messagge}>
        <MobileOffIcon sx={styles(theme).icon} />
        <Typography variant="h5" sx={styles(theme).text}>
          {t('responsive.mobileUnavailable')}
        </Typography>
      </Box>
      <Box sx={styles(theme).logo}>
        <IsoLogo width="40vw" />
      </Box>
    </Box>
  );
};
export default UnsupportedDevice;
